import { Images } from 'utils';

export const filterList = [
    {
        icon: Images.sessionTag,
        title: 'Tags',
        name: 'tag',
        search: true,
    },
    {
        icon: Images.sessionDomains,
        title: 'Domains',
        name: 'domain',
        search: true,
    },
    {
        icon: Images.sessionTypes,
        title: 'Type',
        name: 'type',
    },
    {
        icon: Images.sessionMode,
        title: 'Mode',
        name: 'mode',
    },
    {
        icon: Images.sessionTypes,
        title: 'Sort By',
        name: 'sortBy',
    },
];
